import ClinicPositionsFilterLayout from '@/src/jobPortal/clinicPositions/components/ClinicPositionsFilterLayout';
import useClinicPositions from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';

const ClinicPositionsFilter = () => {
  const {onFilterChange, filter} = useClinicPositions();

  return (
    <ClinicPositionsFilterLayout
      onFilterChange={onFilterChange}
      filter={filter}
    />
  );
};

export default ClinicPositionsFilter;
